export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN ?? null;
